export const enum UserPopupContentTypeEnum {
  /**
   * Login popup show sign in form content
   */
  signIn = 'sign-in',

  /**
   * Login popup show registration form content
   */
  registration = 'registration',

  /**
   * Login popup show forgot password form content
   */
  forgotPassword = 'forgot-password',
}
